import {
  GenericCurrencyInputComponent,
  GenericDateIsoStringInputComponent,
  GenericDisabledTextInputComponent,
  GenericFreeTextInputComponent,
  SelectFixedOrRoundInputComponent,
  SelectLclCostCentreInputComponent,
  GenericPercentageInputComponent,
  GenericNumericInputComponent,
  SelectAndFilterTruckIdInputComponent,
} from "./InputComponents";

export const routeDefinition = {
  id: {
    displayName: "ID",
    displayValue: (entity) => String(entity.id),
    inputComponent: GenericDisabledTextInputComponent,
    isValid: (entity) => true,
  },
  truckId: {
    displayName: "Truck",
    displayValue: (entity) => String(entity.truckId),
    inputComponent: SelectAndFilterTruckIdInputComponent,
    isValid: (entity) => entity.truckId !== undefined,
  },
  routeName: {
    displayName: "Name",
    displayValue: (entity) => String(entity.routeName),
    inputComponent: GenericFreeTextInputComponent,
    isValid: (entity) => entity.routeName !== "",
  },
  dpcTypeId: {
    displayName: "Type",
    displayValue: (entity) => String(entity.dpcTypeId),
    inputComponent: SelectFixedOrRoundInputComponent,
    isValid: (entity) => entity.dpcTypeId !== undefined,
  },
  routeRate: {
    displayName: "Rate",
    displayValue: (entity) =>
      `$${(Math.round(entity.routeRate * 100) / 100).toFixed(2)}`,
    inputComponent: GenericCurrencyInputComponent,
    isValid: (entity) => /^\d+(\.\d{1,6})?$/.test(String(entity.routeRate)),
  },
  adjustmentCostCentre: {
    displayName: "Adjustment Cost Centre",
    displayValue: (entity) => String(entity.adjustmentCostCentre),
    inputComponent: SelectLclCostCentreInputComponent,
    isValid: (entity) => /^\d+$/.test(String(entity.adjustmentCostCentre)),
  },
  costCentre1: {
    displayName: "Cost Centre 1",
    displayValue: (entity) => String(entity.costCentre1),
    inputComponent: SelectLclCostCentreInputComponent,
    // inputComponent: SelectCostCentreInputComponent,
    isValid: (entity) => /^\d+$/.test(String(entity.costCentre1)),
  },
  accountCode1: {
    displayName: "Account Code 1",
    displayValue: (entity) => String(entity.accountCode1),
    inputComponent: GenericNumericInputComponent,
    isValid: (entity) => /^\d+$/.test(String(entity.accountCode1)),
  },
  percentage1: {
    displayName: "Percentage 1",
    displayValue: (entity) =>
      `${parseFloat((entity.percentage1 * 100).toFixed(2))}%`,
    inputComponent: GenericPercentageInputComponent,
    isValid: (entity) => percentageSum(entity),
  },
  costCentre2: {
    displayName: "Cost Centre 2",
    displayValue: (entity) => String(entity.costCentre2),
    inputComponent: SelectLclCostCentreInputComponent,
    // inputComponent: SelectCostCentreInputComponent,
    isValid: (entity) =>
      entity.costCentre2
        ? /^\d+$/.test(String(entity.costCentre2)) &&
          entity.costCentre1 &&
          entity.accountCode1 &&
          entity.percentage1
        : true,
  },
  accountCode2: {
    displayName: "Account Code 2",
    displayValue: (entity) => String(entity.accountCode2),
    inputComponent: GenericNumericInputComponent,
    isValid: (entity) =>
      entity.accountCode2
        ? /^\d+$/.test(String(entity.accountCode2)) &&
          entity.costCentre1 &&
          entity.accountCode1 &&
          entity.percentage1
        : true,
  },
  percentage2: {
    displayName: "Percentage 2",
    displayValue: (entity) =>
      `${parseFloat((entity.percentage2 * 100).toFixed(2))}%`,
    inputComponent: GenericPercentageInputComponent,
    isValid: (entity) =>
      entity.percentage2
        ? percentageSum(entity) &&
          entity.costCentre1 &&
          entity.accountCode1 &&
          entity.percentage1
        : true,
  },
  costCentre3: {
    displayName: "Cost Centre 3",
    displayValue: (entity) => String(entity.costCentre3),
    inputComponent: SelectLclCostCentreInputComponent,
    // inputComponent: SelectCostCentreInputComponent,
    isValid: (entity) =>
      entity.costCentre3
        ? /^\d+$/.test(String(entity.costCentre3)) &&
          entity.costCentre2 &&
          entity.accountCode2 &&
          entity.percentage2
        : true,
  },
  accountCode3: {
    displayName: "Account Code 3",
    displayValue: (entity) => String(entity.accountCode3),
    inputComponent: GenericNumericInputComponent,
    isValid: (entity) =>
      entity.accountCode3
        ? /^\d+$/.test(String(entity.accountCode3)) &&
          entity.costCentre2 &&
          entity.accountCode2 &&
          entity.percentage2
        : true,
  },
  percentage3: {
    displayName: "Percentage 3",
    displayValue: (entity) =>
      `${parseFloat((entity.percentage3 * 100).toFixed(2))}%`,
    inputComponent: GenericPercentageInputComponent,
    isValid: (entity) =>
      entity.percentage3
        ? percentageSum(entity) &&
          entity.costCentre2 &&
          entity.accountCode2 &&
          entity.percentage2
        : true,
  },
  costCentre4: {
    displayName: "Cost Centre 4",
    displayValue: (entity) => String(entity.costCentre4),
    inputComponent: SelectLclCostCentreInputComponent,
    // inputComponent: SelectCostCentreInputComponent,
    isValid: (entity) =>
      entity.costCentre4
        ? /^\d+$/.test(String(entity.costCentre4)) &&
          entity.costCentre3 &&
          entity.accountCode3 &&
          entity.percentage3
        : true,
  },
  accountCode4: {
    displayName: "Account Code 4",
    displayValue: (entity) => String(entity.accountCode4),
    inputComponent: GenericNumericInputComponent,
    isValid: (entity) =>
      entity.accountCode4
        ? /^\d+$/.test(String(entity.accountCode4)) &&
          entity.costCentre3 &&
          entity.accountCode3 &&
          entity.percentage3
        : true,
  },
  percentage4: {
    displayName: "Percentage 4",
    displayValue: (entity) =>
      `${parseFloat((entity.percentage4 * 100).toFixed(2))}%`,
    inputComponent: GenericPercentageInputComponent,
    isValid: (entity) =>
      entity.percentage3
        ? percentageSum(entity) &&
          entity.costCentre3 &&
          entity.accountCode3 &&
          entity.percentage3
        : true,
  },
  costCentre5: {
    displayName: "Cost Centre 5",
    displayValue: (entity) => String(entity.costCentre5),
    inputComponent: SelectLclCostCentreInputComponent,
    // inputComponent: SelectCostCentreInputComponent,
    isValid: (entity) =>
      entity.costCentre5
        ? /^\d+$/.test(String(entity.costCentre5)) &&
          entity.costCentre4 &&
          entity.accountCode4 &&
          entity.percentage4
        : true,
  },
  accountCode5: {
    displayName: "Account Code 5",
    displayValue: (entity) => String(entity.accountCode5),
    inputComponent: GenericNumericInputComponent,
    isValid: (entity) =>
      entity.accountCode5
        ? /^\d+$/.test(String(entity.accountCode5)) &&
          entity.costCentre4 &&
          entity.accountCode4 &&
          entity.percentage4
        : true,
  },
  percentage5: {
    displayName: "Percentage 5",
    displayValue: (entity) =>
      `${parseFloat((entity.percentage5 * 100).toFixed(2))}%`,
    inputComponent: GenericPercentageInputComponent,
    isValid: (entity) =>
      entity.percentage3
        ? percentageSum(entity) &&
          entity.costCentre4 &&
          entity.accountCode4 &&
          entity.percentage4
        : true,
  },
  startDate: {
    displayName: "Start Date",
    displayValue: (entity) =>
      entity.startDate ? entity.startDate.split("T")[0] : "",
    inputComponent: GenericDateIsoStringInputComponent,
    isValid: (entity) => {
      if (entity.startDate && entity.endDate) {
        return entity.startDate <= entity.endDate;
      } else {
        return true;
      }
    },
  },
  endDate: {
    displayName: "End Date",
    displayValue: (entity) =>
      entity.endDate ? entity.endDate.split("T")[0] : "",
    inputComponent: GenericDateIsoStringInputComponent,
    isValid: (entity) => {
      if (entity.startDate && entity.endDate) {
        return entity.startDate <= entity.endDate;
      } else {
        return true;
      }
    },
  },
};

export const defaultRoute = {
  id: 0,
  truckId: undefined,
  routeName: "",
  dpcTypeId: 4,
  routeRate: undefined,
  adjustmentCostCentre: undefined,
  costCentre1: undefined,
  accountCode1: 22006,
  percentage1: undefined,
  costCentre2: undefined,
  accountCode2: 22006,
  percentage2: undefined,
  costCentre3: undefined,
  accountCode3: 22006,
  percentage3: undefined,
  costCentre4: undefined,
  accountCode4: 22006,
  percentage4: undefined,
  costCentre5: undefined,
  accountCode5: 22006,
  percentage5: undefined,
  startDate: undefined,
  endDate: undefined,
};

export const columns = [
  "id",
  "truckId",
  "routeName",
  // "dpcTypeId",
  "routeRate",
  "adjustmentCostCentre",
  "costCentre1",
  // "accountCode1",
  "percentage1",
  "costCentre2",
  // "accountCode2",
  "percentage2",
  "costCentre3",
  // "accountCode3",
  "percentage3",
  "costCentre4",
  // "accountCode4",
  "percentage4",
  "costCentre5",
  // "accountCode5",
  "percentage5",
  "startDate",
  "endDate",
];

const percentageSum = (entity) => {
  const sum =
    (entity.percentage1 || 0) +
    (entity.percentage2 || 0) +
    (entity.percentage3 || 0) +
    (entity.percentage4 || 0) +
    (entity.percentage5 || 0);

  return Math.abs(1 - sum) < 0.0001;
};
